/** @format */
// Load the Scripts and Styles that are critical and needed to be loaded before content load
console.log("critical script loaded");

// styles
import "./styles/main.scss";
